import { Constants } from "../constants/constants";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";

import { Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import Swal from "sweetalert2/dist/sweetalert2.all.js"; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
import { Utils } from "../utils/utils";

@Injectable({
  providedIn: "root",
})
export class RuteroService {
  constructor(private http: HttpClient, private utils: Utils) {}

  public getRutero(idUsuario): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_RUTERO + "/" + idUsuario;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError((err) => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Rutero",
            text: "Error Cargando Rutero.",
            icon: "error",
          });
        }
        return throwError(err);
      })
    );
  }

  public postRutero(params): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_RUTERO;
    return this.http.post<any>(url, params).pipe(
      catchError((err) => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Rutero",
            text: "Verifique la informacion ingresada.",
            icon: "error",
            confirmButtonColor: "#127570",
          });
        }

        return throwError(err);
      })
    );
  }

  public putRutero(params): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_RUTERO;
    return this.http.put<any>(url, params).pipe(
      catchError((err) => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Rutero",
            text: "Error actualizando Rutero.",
            icon: "error",
          });
        }

        return throwError(err);
      })
    );
  }

  public deleteRutero(usuario, sucursal): Observable<any> {
    const url =
      Constants.BASE_URL +
      Constants.URL_RUTERO +
      "/" +
      usuario +
      "/" +
      sucursal;
    return this.http.delete<any>(url).pipe(
      catchError((err) => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Rutero",
            text: "Error eliminado información del rutero.",
            icon: "error",
          });
        }
        return throwError(err);
      })
    );
  }
}
